import { Pill } from '@eventbrite/eds-pill';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { TicketStatus } from '../../../models/tickets';
import './TicketRemainingTicketsStyles.scss';

const TicketStatusLabelByStatus: Record<
    TicketStatus,
    GenericLazyString | null
> = {
    [TicketStatus.soldOut]: gettext('Sold out'),
    [TicketStatus.salesEnded]: gettext('Sales ended'),
    [TicketStatus.unavailable]: gettext('Unavailable'),
    [TicketStatus.onSale]: null,
    [TicketStatus.salesEndSoon]: null,
    [TicketStatus.salesNotStarted]: null,
    [TicketStatus.salesStartAfter]: null,
    [TicketStatus.salesStartSoon]: null,
};
export interface TicketRemainingTicketsCountProps {
    numTicketsRemaining: number | null;
    statusKey: TicketStatus;
    className?: Parameters<typeof classNames>[0];
}
const TicketRemainingTicketsCount: FunctionComponent<
    TicketRemainingTicketsCountProps
> = ({ numTicketsRemaining, className, statusKey }) => {
    const ticketStatusLabel = TicketStatusLabelByStatus[statusKey];

    const dataTestid = 'remaining-tickets';
    const baseClasses = ['ticket-remaining-tickets-pill', className];

    if (ticketStatusLabel) {
        return (
            <Pill
                className={classNames(
                    'ticket-remaining-tickets-pill--sold-out',
                    baseClasses,
                )}
                dataTestid={dataTestid}
            >
                {ticketStatusLabel}
            </Pill>
        );
    }

    if (numTicketsRemaining) {
        return (
            <Pill className={classNames(baseClasses)} dataTestid={dataTestid}>
                {gettext('%(numTicketsRemaining)s Remaining', {
                    numTicketsRemaining,
                })}
            </Pill>
        );
    }
    return null;
};

export default TicketRemainingTicketsCount;
